import { IModuleTrackingData } from 'homepage/types/ModuleTrackingData';

/**
 * [getBrandFeedTrackingInfo]
 * All of the tracking events for brand feed space content require these attributes.
 *
 * @param   {Object} moduleTrackingData        The base tracking data of the section the subsection is in
 * @param   {String} subsectionUrl             The url passed to the function on click
 * @returns {Object}
 */

export const getBrandFeedTrackingInfo = (
  moduleTrackingData: IModuleTrackingData,
  subsectionUrl: string,
) => {
  const collectionAttr = {
    collection_id: null,
    collection_slug: null,
    product_template_slug: null,
  };

  const slug =
    subsectionUrl?.split('/')?.[1] === 'collections' || subsectionUrl?.split('/')?.[1] === 'brand'
      ? subsectionUrl?.split('/')?.[2]
      : null;

  collectionAttr.collection_slug = slug;

  /*
   * the null fields are temporary until we can get the shared space component updated
   * to pass more verbose tracking data back about the clicked section
   */
  return {
    ...moduleTrackingData,
    sub_section_id: null,
    sub_section_position: null,
    sub_section_type: 'SpaceItemSection',
    sub_section_name: subsectionUrl,
    item_position: null,
    ...collectionAttr,
  };
};
